<div class="profile-page bg-secondary">
    <main class="pt-3">
        <div class="container wow fadeIn">
            <legend>Customer Transactions Report</legend>
            <!--Grid row-->
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Account No:" label-for="input-1">
                        <b-form-input size="sm" v-model="accountNo" input-class="form-control"
                            placeholder="Account No"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Product:" label-for="input-1">
                        <b-form-input size="sm" v-model="product" input-class="form-control" placeholder="Product"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Merchant Reference:" label-for="input-1">
                        <b-form-input size="sm" v-model="merchantReference" input-class="form-control"
                            placeholder="Merchant Reference"></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="Reference:" label-for="input-1">
                        <b-form-input size="sm" v-model="reference" input-class="form-control"
                            placeholder="Reference"></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="From Date:" label-for="input-1">
                        <datepicker size="sm" v-model="fromDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="To Date:" label-for="input-1">
                        <datepicker v-model="toDate" input-class="form-control form-control-sm" :format="customFormatter"
                            placeholder="Select from date"></datepicker>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="6">
                    <b-form-group label-size="sm" label="State">
                        <b-form-select size="sm" v-model="readbleStateValue" :options="readbleStateOptions"></b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <br />
                          <b-button type="button" @click="getTransactions" pill  variant="outline-dark">
                            Retrieve Report
                        </b-button>
                </b-col>
                <b-col sm="12" md="2" >
                    <br />
                          <b-button type="button" @click="printReport" pill  variant="outline-dark">
                            Download CSV Report
                        </b-button>
                </b-col>
            </b-row>
            <b-row>
                <b-col>
                    <strong>Total Transactions : {{totalRecords}}</strong>
                </b-col>

                    

            </b-row>
            <div class="row pt-3">
                <div class="table-responsive">
                    <b-table striped hover bordered :items="items" :fields="fields">
                        <template #cell(state)="data">
                            <span>
                                <b-badge
                                    :variant="badgeVarient(data.item.state)">{{data.item.state}}</b-badge>
                            </span>
                        </template>
                        <template #cell(createdOn)="data">
                            <span>{{customFormatterWithTime(data.item.createdOn)}}</span>
                        </template>
                        <template #cell(updatedOn)="data">
                            <span>{{customFormatterWithTime(data.item.updatedOn)}}</span>
                        </template>

                    </b-table>
                    <br />
                    <b-pagination @input="handlePageClick" v-model="selectedPage" :total-rows="totalRecords"
                        :per-page="perPage" first-number last-number></b-pagination>
                </div>
            </div>
            <!--spinner-->
            <div class="vld-parent">
                <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="true"></loading>
            </div>
            <!--spinner-->
            <!--Grid row-->
        </div>
    </main>
    <!--Main layout-->
</div>